'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var MenuTrigger =
/*#__PURE__*/
function () {
  function MenuTrigger(triggerButton) {
    _classCallCheck(this, MenuTrigger);

    this.header = document.querySelector('.header');
    this.sideMenuContainer = this.header.querySelector('.side-menu');
    this.sideMenuBg = this.header.querySelector('.side-menu__bg');
    this.menuTrigger = triggerButton;
    this.init();
  }

  _createClass(MenuTrigger, [{
    key: "toggleSideMenu",
    value: function toggleSideMenu() {
      this.sideMenuContainer.classList.toggle('side-menu--is-open');
    }
  }, {
    key: "setListeners",
    value: function setListeners() {
      var _this = this;

      this.menuTrigger.addEventListener('click', function () {
        _this.toggleSideMenu();
      });

      if (this.sideMenuBg) {
        this.sideMenuBg.addEventListener('click', function () {
          _this.toggleSideMenu();
        });
      }
    }
  }, {
    key: "init",
    value: function init() {
      this.setListeners();
    }
  }]);

  return MenuTrigger;
}();

define(['scrollbar'], function (SimpleBar) {
  return function (options, element) {
    new MenuTrigger(element);
    var sideMenuScrollbar = new SimpleBar(document.querySelector('.side-menu__wrapper'));
    window.addEventListener('resize', function () {
      sideMenuScrollbar.recalculate();
    });
  };
});
//# sourceMappingURL=menu-trigger.babel.js.map
